/** basic.deviceModel */
export default {
    modelName: "Название модели",
    model_NamePla: "Введите название модели",
    table_modelName: "Название устройства",
    table_model: "Модель (шаблон)",

    model_drawer: "Детали модели устройства",
    model_dialog: "Новая модель устройства",

    rules_modelNoVacancy: "Модель устройства не может быть пустой",
    form_deviceID: "ID модели устройства",
    form_deviceIDPla: "Введите ID модели устройства",
    form_modelCodingPla: "Введите код модели",
    form_modelIntro: "Описание модели",
    form_modelIntroPla: "Введите описание модели",
    form_deviceModel: "Шаблон устройства",
    form_LowVoltage: "Минимальное напряжение",
    form_LowVoltagePla: "Введите минимальное напряжение",
    form_LowVoltageNum: "Количество низких напряжений",
    form_LowVoltageNumPla: "Введите количество",
    form_lowSignal: "Минимальный уровень сигнала",
    form_lowSignalPla: "Введите минимальный уровень сигнала",
    form_SiganWeakNum: "Количество слабого сигнала",
    form_SiganWeakNumPla: "Введите количество",
    form_deviceMoelPlaNo: "Введите шаблон устройства",
    ruler_modelName: "Название модели не может быть пустым",
    ruler_modelLength: "Длина 1–20",
    ruler_modelCoding: "Код модели не может быть пустым!",
    ruler_modelIntro: "Описание модели не может быть пустым!",
    ruler_devcieModel: "Шаблон устройства не может быть пустым!",
    message_addModelSucc: "Модель добавлена!",
    message_addModelLose: "Не удалось добавить модель!",

    modelImg: "Изображение модели",
    useManual: "Руководство пользователя",
    addUseManual: "Добавить руководство",
    delTips:
        "Перед удалением отметьте данные и проверьте подтверждение удаления выбранных записей.",
    dels: "Массовое удаление",
    confirmDelUM: "Удалить это руководство?",
    file: "Файл",
    fileDawnload: "Скачать файл",
    fileName: "Имя файла",
    uoloadFile: "Загрузить файл",
    file10MB: "Файл не должен превышать 10 МБ",
    fileSizeIS: "Размер файла не должен превышать 10 МБ. Текущий размер:",
}

